// extracted by mini-css-extract-plugin
export var layoutContainer = "_am-0";
export var layoutContainerNoRounding = "_am-6";
export var layoutContainerOpen = "_am-5";
export var layoutContainerResizing = "_am-1";
export var mainContent = "_am-2";
export var resizeDivider = "_am-3";
export var slidePanel = "_am-4";